<template>
  <div>
    <div>
      <div class="payment marTop10 XYcenter">
        <i v-if="fileUrl != ''" class="el-icon-delete dele-icon" @click="clearImg"></i>
        <i class="el-icon-plus" style="font-size:30px;"></i>
        <img v-if="coverImageUrl" :src="coverImageUrl" class="avatar pointer">
        <img v-else v-show="fileUrl" :src="fileUrl" class="avatar pointer">
        <input type="file" ref="uploadInput" :accept="accept" @change="filesUpFn($event)" :disabled="readonly">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'upload-file',
  components:{
  },
  props:{
    fileUrl:'',
    infoname:{ // 只读，详情时用到
        type: Boolean,
        default: false
    },
    readonly: { // 只读，详情时用到
                type: Boolean,
                default: false
            },
    accept: { // 上传的文件类型
                type: String, // text/plain, application/zip
                default: '*'
            },
  },
  data () {
    return { 
      imgid:'',
      coverImage:'',
      coverImageUrl:'',
    }
  },
  watch: {
    fileUrl: {
        handler(val) {
            if(val == null) val = ''
            this.init(val)
        },
        immediate: true
      },
  },
  methods: {
    init(val) {
        if (!val) {
          this.$nextTick(() => {
              if (this.$refs['uploadInput']){
                this.$refs['uploadInput'].value = ''
                this.coverImage = this.coverImageUrl = ''
              }
          })
          return
        }else{
          const imgType = ['jpg', 'png', 'jpeg', 'JPG', 'PNG', 'JPEG']
          const hz = val.split('.')[val.split('.').length-1]
          if(imgType.indexOf(hz) !== -1){
            this.fileUrl = this.coverImage = val
          }else{
            this.fileUrl = val
            this.coverImageUrl = require(`@/assets/image/${hz}.png`)
          }
        }
    },
    clearImg(){
      this.coverImage = this.fileUrl = ''
      this.$emit('updataUrl','')
    },
    filesUpFn(el){
        let fileObj = el.currentTarget.files[0];
        let isLt8M = fileObj.size / 1024 / 1024 < 50;
        if (!isLt8M) {
          this.$message({
            message: '上传文件大小不能超过 50MB!',
            type: 'warning',
            duration: 1500
          });
          return false;
        }
        this.ajax.UploadFiles('/File',fileObj,'businessCharge').then(res => {
          let resp = res.data
          this.fileUrl = this.coverImage = resp[0].cdnUrl
          if(resp[0].cdnUrl.indexOf('zip') != -1){
            this.coverImageUrl = require('@/assets/image/zip.png')
          }
          console.log(this.coverImageUrl)
          this.$emit('updataUrl',resp[0].cdnUrl)
        })
      }
  }
}
</script>

<style scoped>
.payment{
    width:80px;
    height:80px;
    border: 1px dashed #DCDFE6;
    border-radius:8px;
    color: #DCDFE6;
    position: relative;
  }
  .payment input{
    position: absolute;
    left: 0;
    top: 0;
    z-index: 10;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }
  .avatar {
    width:80px;
    height:80px;
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    display: block;
  }
  .dele-icon{
    position: absolute;
    top: 3px;
    right: 3px;
    font-size: 20px;
    cursor: pointer;
    z-index: 99;
  }
</style>


// WEBPACK FOOTER //
// src/components/upload/upload.vue